<template>
  <div class="up-mask boxmain">
    <div class="desc">
      <br />
      <p style="margin-top: 50px;">
        <img src="../../../assets/image/pm/guidelogo.png" width="310px" />
      </p>
      <span class="link" style="margin-left: 5px;" @click="close"
        >关闭指引</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'Main',
  methods: {
    close() {
      this.$emit('guideLogoToCloseBox', false);
    },
  },
};
</script>

<style scoped lang="less" type="text/less">
@import '../../../assets/style/color.less';
@import '../../../assets/style/config.less';
@import '../../../assets/style/mixin.less';

.boxmain {
  display: flex;
  justify-content: center;
}

.up-mask {
  background-color: fade(black, 70);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100vh;
  z-index: 2000;
  text-align: center;
  padding: 0 12px;
  .desc {
    color: white;
    .link {
      margin-top: 30px;
      display: inline-block;
      padding: 0 15px;
      color: #ffffff;
      font-weight: 400;
      font-size: 14px;
      line-height: 35px;
      border-radius: 2px;
      text-decoration: none;
      border: 0;
      outline: 0;
      background: #166df1 none;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/global/Up/guideLogo.vue